import clsx from 'clsx'

interface PageCitationProps {
  pages: number[]
  highlighted?: boolean
  onClick?: () => void
}

/**
 * Page Citation
 *
 * Displays a clickable button for a page citation, supports both single and multiple page citations.
 */
export default function PageCitation(props: PageCitationProps) {
  const { pages, highlighted = false, onClick } = props

  if (pages.length === 0) return null

  // Convert pages to 1-based index for display
  const displayPages = pages.map((page) => page + 1)

  const label = displayPages.length === 1 ? `p. ${displayPages[0]}` : `pp. ${displayPages.join(', ')}`

  return (
    <button
      onClick={onClick}
      className={clsx(
        'text-xs whitespace-nowrap rounded-sm py-0.5 px-1.5 min-h-5 transition-colors font-medium text-brand-neutral-800 hover:text-brand-800',
        highlighted ? 'bg-yellow-200 cursor-default' : 'bg-brand-neutral-200 hover:bg-brand-neutral-300'
      )}
      aria-disabled={highlighted}
      disabled={highlighted}
    >
      {label}
    </button>
  )
}
